export default __webpack_public_path__ + "static/media/ic_puppy_24.80a4ca86.svg";